// The campaign entity type is only used to match up with the content type
// of a feed item. Once that is determined to be true, the other campaign
// content types are then used to replace this one for deciding which
// type of actual content is showed in <EntitySummaryDetailsContent>.

enum EntityContentType {
  ANNOUNCEMENT = 'announcement',
  CAMPAIGN = 'campaign',
  CAMPAIGN_CREATED = 'campaign_created',
  CAMPAIGN_GOAL_MET = 'campaign_goal_met',
  CAMPAIGN_STRETCH_GOAL_ADDED = 'campaign_stretch_goal_added',
  CAMPAIGN_STRETCH_GOAL_MET = 'campaign_stretch_goal_met',
  COMMS = 'comms',
  DONATION = 'donation',
  EMAIL_RECEIVED = 'email_received',
  EMAIL_SENT = 'email_sent',
  INTERACTION = 'interaction',
  OPPORTUNITY = 'opportunity',
  TASK = 'task',
}

export default EntityContentType;
